import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Banner.css';

function Banner() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const slides = [
    "https://rukminim2.flixcart.com/fk-p-flap/3240/540/image/1338bd4fc60390d8.jpg?q=60",
    "https://rukminim2.flixcart.com/fk-p-flap/1620/270/image/fb28e3e1d22e6da2.jpg?q=80",
    "https://rukminim2.flixcart.com/fk-p-flap/3240/540/image/c3b3988bf82de15b.jpeg?q=60"
  ];

  const goToSlide = (index) => {
    setIsAutoPlaying(false);
    setCurrentSlide(index);
    setTimeout(() => setIsAutoPlaying(true), 5000); // Resume auto-play after 5 seconds
  };

  const goToPrev = () => {
    goToSlide((currentSlide - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    goToSlide((currentSlide + 1) % slides.length);
  };

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, slides.length]);

  return (
    <div className="banner-container">
      <div className="slider-container">
        <div 
          className="slider" 
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div className="slide" key={index}>
              <img className="slide-img" src={slide} alt={`Banner ${index + 1}`} />
            </div>
          ))}
        </div>
        <button className="slider-btn prev-btn" onClick={goToPrev}>
          <FaChevronLeft className="icon" />
        </button>
        <button className="slider-btn next-btn" onClick={goToNext}>
          <FaChevronRight className="icon" />
        </button>
        <div className="slider-dots">
          {slides.map((_, index) => (
            <span 
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Banner;